import { render, staticRenderFns } from "./UpdateProofOfAddressModal.vue?vue&type=template&id=32dce33c&scoped=true&"
import script from "./UpdateProofOfAddressModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateProofOfAddressModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateProofOfAddressModal.vue?vue&type=style&index=0&id=32dce33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dce33c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon,VRow})
